export default "__VITE_ASSET___HenejpC__"